// "Together for Nepal" flood-relief campaign — 3E Entertainment × Global Family
// Foundation. Copy mirrors the campaign flyer at `flyer` below.
//
// Set `active: false` when the campaign ends: that hides the site-wide popup and
// the homepage section, and restores the tour announcement popup on the
// homepage (see components/home/TourAnnouncement.jsx).

export const NEPAL_RELIEF_DISMISS_KEY = "nepal_relief_dismissed";

export const NEPAL_RELIEF = {
  active: true,
  partner: "Global Family Foundation",
  eyebrow: "3E Entertainment × Global Family Foundation",
  title: "Together for Nepal",
  subtitle: "Music with a Purpose",
  intro:
    "In response to the devastating floods affecting families and communities across Nepal, 3E Entertainment, in collaboration with Global Family Foundation, is turning our upcoming events and tours into a platform for relief and support.",
  ticketDeadline: "September 10",
  contribution:
    "3E Entertainment has already contributed NPR 100,000 (Rs. 1 Lakh) toward supporting those affected.",
  invitation:
    "We invite our entire community to stand with us. If you are planning to attend DTFEST VA or DTFEST NE, please purchase your tickets online before September 10.",
  assurance:
    "Together with Global Family Foundation, we will work to ensure this effort reaches those who need it most, and we will continue to share updates on the funds raised and their distribution.",
  closing: "Every ticket matters. Every show matters. Every contribution matters.",
  kicker: "Two tours. Two DTFests. One purpose.",
  flyer: "/images/together-for-nepal.jpg",
  flyerAlt:
    "Together for Nepal — 3E Entertainment and Global Family Foundation flood relief campaign flyer",
  commitments: [
    {
      id: "dtfest",
      title: "DTFEST Virginia + DTFEST New England",
      meta: "Online tickets through September 10",
      detail:
        "50% of online ticket proceeds from today through September 10 will be donated toward Nepal flood relief.",
      ctaLabel: "Get tickets",
      to: "/all-events",
    },
    {
      id: "mukti-revival",
      title: "Mukti & Revival",
      meta: "30 Year Anniversary USA Tour",
      detail: "$500 from every show will be contributed toward the relief effort.",
      ctaLabel: "Book this tour",
      to: "/book-a-tour/mukti-revival",
    },
    {
      id: "dashain-tihar-dhamaka",
      title: "Samikshya Adhikari & Shiva Pariyar",
      meta: "USA Tour 2026",
      detail: "$500 from every show will be contributed toward the relief effort.",
      ctaLabel: "Book this tour",
      to: "/book-a-tour/dashain-tihar-dhamaka",
    },
  ],
};

// Dispatched on `window` when the relief popup is closed, so the other
// auto-opening popups can take their turn in the same session.
export const NEPAL_RELIEF_EVENT = "nepal-relief:dismissed";
